import { render, staticRenderFns } from "./ModalSessionTimeout.vue?vue&type=template&id=63e6b672&"
import script from "./ModalSessionTimeout.vue?vue&type=script&lang=js&"
export * from "./ModalSessionTimeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports